'use client';

import { useOptionsForHDYHAU } from '@/app/(intakeFormV2)/intake-v2/components/steps/ContactInfoStep';
import { useParams } from 'next/navigation';
import { IntakeStepSwitcher } from '../components/IntakeStepSwitcher';
import { IntakeWizardLayout } from '../components/IntakeWizardLayout';
import { useIntakeWizardContext } from '../contexts/WizardProvider';
import { useWizardNavigation } from '../hooks/useWizardNavigation';

import { cn } from '@/lib/ui/cn';
import './StepPage.scss';

export const StepPage = () => {
  const { currentStep, visibleSteps, currentStepIndex } = useWizardNavigation();
  const params = useParams();
  const stepSlug = params.step as string;
  const { state } = useIntakeWizardContext();

  const { isLoading: optionsLoading } = useOptionsForHDYHAU(
    currentStep?.slug === 'contact-info'
  );

  const isLoading = state.isLoading || optionsLoading;

  if (!currentStep) {
    return (
      <IntakeWizardLayout currentStepIndex={0} totalSteps={visibleSteps.length}>
        <div className='StepPage__content--missing-step flex flex-1 items-center justify-center'>
          <p className='text-sh-gray-dark'>
            The step &quot;{stepSlug}&quot; was not found.
          </p>
        </div>
      </IntakeWizardLayout>
    );
  }

  return (
    <IntakeWizardLayout
      currentStepIndex={currentStepIndex}
      totalSteps={visibleSteps.length}
      hideMobileBackButton={
        stepSlug === 'location-check' || stepSlug === 'quote-edit'
      }
      className={cn('StepPage', `StepPage--${currentStep.slug}`)}
    >
      {isLoading && (
        <div className='StepPage__loader'>
          <div className='StepPage__content--loading flex flex-1 items-center justify-center'>
            <div className='border-sh-sky h-8 w-8 animate-spin rounded-full border-b-2' />
          </div>
        </div>
      )}

      {!isLoading && <IntakeStepSwitcher stepConfig={currentStep} />}
    </IntakeWizardLayout>
  );
};

export default StepPage;
